import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Translator } from 'ggApp/modules/translator';

import { SEARCH_OVERLAY_ACTION } from 'ggApp/modules/gaAnalytics/constants';
import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import { Wrap, Line, ProductSection, Product } from './styles';
import { SegmentEvents } from '../../../../../../../../packages/analytics/events';

const getTk = (withSearchedProducts, totalItems) => {
    if (withSearchedProducts) {
        return totalItems === 1 ? 'SEARCHBAR_RESULTS_QTY_SHORT' : 'SEARCHBAR_RESULTS_QTY';
    }
    return 'SEARCHBAR_TRENDING_PRODUCTS';
};

const Products = ({
    className,
    products,
    totalItems,
    withSearchedProducts,
    handleClick,
    query,
    storeActive,
    registerSearchOverlayEvent,
}) => {
    const handleClickWithGtmEvent = useCallback(
        (product) => () => {
            const { name, sku } = product || {};
            const { store_id: storeId } = storeActive;
            registerSearchOverlayEvent(SEARCH_OVERLAY_ACTION.productClick, { name, sku });
            sendAnalyticsEvent(SegmentEvents.searchProductClicked, {
                store_id: storeId ?? '',
                search_term: query,
                product_name: name,
                product_sku: sku,
            });
            handleClick();
        },
        [storeActive, registerSearchOverlayEvent, query, handleClick],
    );
    return (
        <Wrap className={className}>
            <Line
                title={
                    <Translator
                        tk={getTk(totalItems, withSearchedProducts)}
                        withValues={{ totalItems }}
                    />
                }
            />
            <ProductSection>
                {products.map((product) => (
                    <Product
                        handleClick={handleClickWithGtmEvent(product)}
                        key={product.id}
                        product={product}
                        cardType="horizontal"
                    />
                ))}
            </ProductSection>
        </Wrap>
    );
};

Products.propTypes = {
    className: PropTypes.string,
    query: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.object),
    withSearchedProducts: PropTypes.bool,
    handleClick: PropTypes.func,
    totalItems: PropTypes.number,
    registerSearchOverlayEvent: PropTypes.func,
};

Products.defaultProps = {
    className: '',
    products: [],
    withSearchedProducts: false,
    handleClick: () => {},
    totalItems: null,
    query: '',
    registerSearchOverlayEvent: () => {},
};

export default Products;
